import classNames from "classnames"
import styled from "styled-components"

import { WidgetContractors } from "components/widgets/WidgetContractors"
import { WidgetInstaledDevices } from "components/widgets/WidgetInstaledDevices"
import { WidgetPhysicalStatus } from "components/widgets/WidgetPhysicalStatus"
import { WidgetSTAndMemberships } from "components/widgets/WidgetSTAndMemberships"
import { WidgetVendorAlerts } from "components/widgets/WidgetVendorAlerts"
import { WidgetVendorAlertStatuses } from "components/widgets/WidgetVendorAlertStatuses"
import { WidgetVendorOrderStatus } from "components/widgets/WidgetVendorOrderStatus"
import { WidgetWarehouseInformation } from "components/widgets/WidgetWarehouseInformation"

import CustomerTrends from "./components/CustomerTrendsWidget"
import InstallationTrends from "./components/InstallationTrendsWidget"
import ReordersWidgetOld from "./components/ReordersWidgetOld"

import styles from "./index.module.scss"

const WidgetRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 12px;
  gap: 24px;
`

export const Dashboard = () => {
  return (
    <div className={styles.widgetsWrapper}>
      <div className={styles.widgetsRowWrapper}>
        <h2 className={styles.widgetsRowTitle}>Devices</h2>
        <div className={styles.widgetsRow}>
          <WidgetPhysicalStatus />
          <WidgetInstaledDevices />
        </div>
      </div>
      <div className={styles.widgetsRowWrapper}>
        <h2 className={styles.widgetsRowTitle}>Trends</h2>
        <WidgetRow>
          <InstallationTrends />
          <CustomerTrends />
          <ReordersWidgetOld />
        </WidgetRow>
      </div>
      <div className={styles.widgetsRowWrapper}>
        <h2 className={styles.widgetsRowTitle}>Orders</h2>
        <div className={styles.widgetsRow}>
          <WidgetWarehouseInformation />
          <WidgetVendorOrderStatus />
        </div>
      </div>
      <div className={styles.widgetsHalfRowWrapper}>
        <div className={classNames(styles.widgetsRowWrapper, styles.half)}>
          <h2 className={styles.widgetsRowTitle}>Contractors/Integration</h2>
          <div className={styles.widgetsRow}>
            <WidgetContractors />
            <br />
            <WidgetSTAndMemberships />
          </div>
        </div>
        <div className={classNames(styles.widgetsRowWrapper, styles.half)}>
          <h2 className={styles.widgetsRowTitle}>Alerts</h2>
          <div className={styles.widgetsRow}>
            <WidgetVendorAlerts />
            <br />
            <WidgetVendorAlertStatuses />
          </div>
        </div>
      </div>
    </div>
  )
}
